export default __webpack_public_path__ + "static/media/pos3.53bdd115.png";